"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
class UserProvider extends DataProvider_1.default {
    get fragments() {
        return {
            User: () => `
        ... on User {
          id
          role
          screenName
          username
          phone
          email
          emailVerified
          accountInfo {
            timeZone
            registrationTime
            registrationIp
            referralUrl
            lastLoginTime
            lastLoginIp
            disabled
          }
          avatar {
            ${this.getFragment("File")}
          }
          partner
        }`,
        };
    }
    search({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("usersSearch", { data }, this.getPageableFragment("User"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation($data: inputUser!) {
          user(data: $data) {
            ${this.getFragment("User")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.user;
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation($data: inputUserAdd!) {
          userAdd(data: $data) {
            ${this.getFragment("User")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.userAdd;
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation($id: ID!) {
          userDelete(id: $id)
        }
      `,
                variables: { id },
            });
            return resp.data.userDelete;
        });
    }
    disable({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation($id: ID!, $disableReason: String, $disable: Boolean!) {
          userDisable(id: $id, disableReason: $disableReason, disable: $disable)
        }
      `,
                variables: Object.assign({}, data),
            });
            return resp.data.userDisable;
        });
    }
    getMyAuthorities() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query {
          getMyAuthorities {
            role
            authorities
          }
        }
      `,
            });
            return resp.data.getMyAuthorities;
        });
    }
}
exports.UserProvider = UserProvider;
//# sourceMappingURL=UserProvider.js.map